import {
  addIndex,
  assoc,
  both,
  clone,
  complement,
  compose,
  curry,
  equals,
  find,
  has,
  includes,
  is,
  isEmpty,
  isNil,
  join,
  keys,
  map,
  mergeAll,
  not,
  pathOr,
  pipe,
  prop,
  propOr,
  props,
  reduce,
  reject,
  replace,
  sortBy,
  toLower,
  whereEq,
} from 'ramda'
import moment from 'moment'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export const range = (start, end) => {
  return [...Array(end).keys()].map((el) => el + start)
}

export const debounce = (func, wait, immediate) => {
  let timeout

  return function executedFunction() {
    const context = this
    const args = arguments

    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }

    const callNow = immediate && !timeout

    clearTimeout(timeout)

    timeout = setTimeout(later, wait)

    if (callNow) func.apply(context, args)
  }
}

export const throttle = (func, ms) => {
  let isThrottled = false,
    savedArgs,
    savedThis

  function wrapper() {
    if (isThrottled) {
      savedArgs = arguments
      savedThis = this
      return
    }

    func.apply(this, arguments)

    isThrottled = true

    setTimeout(function () {
      isThrottled = false
      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs)
        savedArgs = savedThis = null
      }
    }, ms)
  }

  return wrapper
}

export const getID = () => {
  return (
    new Date().getUTCMilliseconds().toString() + new Date().getTime().toString()
  ).toString()
}

export const sortByNameCaseInsensitive = sortBy(compose(toLower, prop('name')))

export const isNumber = both(is(Number), complement(equals(NaN)))

export const replaceSpace = replace(/\s/g, '')

export const validTime = (string) => {
  return (
    /^\s*$/.test(string) || /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(string)
  )
}

export const replaceApi = replace(/\/api\/v1/g, '')

export const isDisabledDate = (data) => {
  if (data) {
    const dateEnd = new Date(data).valueOf()
    const currentDate = new Date().valueOf()

    const year = moment(new Date(data)).year()
    const currentYear = moment(new Date()).year()

    return currentDate > dateEnd && year < currentYear
  }
  return false
}

export const getDataCope = (data) => {
  return isDisabledDate(data) ? clearTime(new Date()) : clearTime(data)
}

export const clearTime = (data) => {
  if (isNil(data)) {
    return data
  }
  return moment(new Date(data))
    .hours(0)
    .minutes(0)
    .seconds(0)
    .milliseconds(0)
    .toString()
}

export const timestampToDate = (timestamp) => {
  return moment.unix(timestamp).toDate()
}

export const dateToTimestamp = (date) => {
  return moment(date).unix()
}

export const getDates = (startDate, endDate) => {
  let dateArray = []
  let currentDate = moment(new Date(startDate))
  const stopDate = moment(new Date(endDate))

  while (currentDate <= stopDate) {
    dateArray.push(clearTime(currentDate))
    currentDate = moment(currentDate).add(1, 'days')
  }
  return dateArray
}

export const getFullName = (value) => {
  const hasFoolName = has('foolName')(value)
  if (hasFoolName) {
    return value.foolName
  }
  return pipe(props(['surname', 'name', 'patronymic']), join(' '))(value)
}

export const notEmpty = pipe(isEmpty, not)

export const mapIndexed = addIndex(map)

export const numberMask = createNumberMask({
  prefix: '',
  allowDecimal: true,
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ' ',
  allowNegative: false,
})

export const toNumber = (value) => {
  if (is(Number, value)) {
    return value
  }

  if (is(String, value)) {
    return pipe(
      replace(/ /g, ''),
      replace(/,/g, ''),
      replaceSpace,
      Number
    )(value)
  }

  return 0
}

export const getCurrentKindsSport = curry(
  (currentSchoolId, currentSchoolType, currentUser) => {
    return pipe(
      propOr([], 'schools'),
      find(
        whereEq({
          id: currentSchoolId,
          type: currentSchoolType,
        })
      ),
      propOr([], 'kindsSport')
    )(currentUser)
  }
)

export const getDateFilter = (date) => {
  if (date) {
    return moment(new Date(date)).format('MM.YYYY')
  }

  return moment(new Date()).format('MM.YYYY')
}

export const isNotString = pipe(is(String), not)

export const getKindsSport = pipe(propOr([], 'kindsSports'), pathOr(null, [0]))

export const includesStringByKey = curry((key, string, value) =>
  pipe(
    pipe(propOr('', key), toLower, replace(/,/g, '')),
    includes(toLower(string))
  )(value)
)

export const renameKeys = curry((keysMap, obj) =>
  reduce((acc, key) => assoc(keysMap[key] || key, obj[key], acc), {}, keys(obj))
)

export const ramdaLog = curry((name, val) => {
  // eslint-disable-next-line no-console
  console.log(val, name)
  return val
})

export const rejectParams = (params) =>
  pipe(reject(isEmpty), reject(isNil))(params)

export const getIsAdmin = (user) => {
  return includes(user.type, ['admin', 'Адміністратор'])
}

export const propData = curry((paramsDefault, object) => {
  return mergeAll([paramsDefault, clone(object)])
})
